/* global N2 */
import WebpackerReact from 'webpacker-react'
import Rails from "@rails/ujs";
import { NotesPanel } from "n2-styles";
import SortablePubJobsList from '../react/SortablePubJobsList'
import SharedFileOpener from '../components/SharedFileOpener'
import CopyFieldToClipboard from '../components/CopyFieldToClipboard'
import PrepressPublicationJobsSortTable from '../react/PrepressPublicationJobsSortTable'
import N2StylesModal from '../components/N2StylesModal'
import AssetUploader from '../components/uploads/AssetUploader'
import CsrFilter from '../components/CsrFilter'
import CsrSortablePublicationJobsList from '../react/CsrSortablePublicationJobsList'
import CreativeDirectorSortablePublicationJobsList from "../react/CreativeDirectorSortablePublicationJobsList";

export default class PublicationJobs {
  constructor(params) {
    this.params = params;
    this.adminFormEvents();
    this.role = params.role || null
  }

  index() {
    let keys;
    let klass;
    switch(this.role) {
      case "area_director":
        keys = ["my", "cross"]
        klass = SortablePubJobsList
        return this.sortPubs(keys, klass)
        break;
      case "prepress":
        let list = new PrepressPublicationJobsSortTable({
          sortScope: '#sort-filters-prepress-users',
          selector: `.js-prepress-pubs-table`,
          data: $('.js-prepress-pubs-table').data("jobs"),
          statuses: $('.js-prepress-pubs-table').data("statuses"),
          roleType: "prepress",
          beforeRender: this.updateFilter,
        });
        list.render()
        break;
      case "csr":
        this.csrFilter = new CsrFilter({selector: "#filter-csr-rep"});
        keys = ["csr_notes", "proof_out", "in_csr_revisions", "csr_revisions"];
        klass = CsrSortablePublicationJobsList
        return this.sortPubs(keys, klass)
        break;
      case "creative_director": case "quality_assurance":
        if ($(".js-design_revisions-pubs-table") || $(".js-in_design_revisions-pubs-table")) {
          klass = CreativeDirectorSortablePublicationJobsList;
          keys = ["design_revisions", "in_design_revisions"];
          return this.sortPubs(keys, klass);
        }
        break;
    }
  }

  updateFilter({ sortScope, sortKey }) {
    if ($("#current-prepress-filter")) {
      $('#current-prepress-filter').text($(`${sortScope} li[data-title="${sortKey}"]`).data("name"));
    }
    $(`${sortScope} li[data-title="${sortKey}"]`).children(".text-right").children().removeClass("d-none")
  }

  // view uses index view
  cross_sale(){
    this.index();
  }

  // view uses index view
  all(){
    this.index();
  }

  assetUploadUrl() {
    return '/publication_jobs/' + this.params.id + '/address_list_asset';
  }

  assetUploadImageLabel() {
    return "Photos"
  }

  show() {
    WebpackerReact.setup({ NotesPanel });
    this.assetUploader = new AssetUploader(this);
    this.assetUploader.init();

    let sfo = new SharedFileOpener();
    sfo.attach();
    new CopyFieldToClipboard();

    this.bindFinishButtons();
    if (this.params.assignmentNotice) {
      new N2Styles.toast(`FYI this job is already assigned to ${this.params.assignedTo}`, {persistent: true})
    }
    this.bindDesignErrorHandler();
    switch(this.role) {
      case "prepress":
      this.bindPrepressForm()
      if ($('.js-prepress-submit').length) {
        this.bindPrepressSubmit()
      }
      break;
    }
    this.bindProofTypeHandler();
    this.bindManagedListUpload();
  }

  adminFormEvents() {
    N2.bindHandler('change', "#destroy_future", (evt) => {
      $(".future_destroy_checked").val(evt.currentTarget.checked)
    })
  }

  bindPrepressForm(){
    let val = $(".js-mail-input").val()
    N2.bindHandler('blur', ".js-mail-input", (evt) => {
      if ($(".js-mail-input").val() != val){
        $('.js-mail-form').submit()
      }
    })

    N2.bindHandler("click", ".js-production-instructions", (evt) => {
      evt.preventDefault();
      new N2StylesModal(".js-production-instructions-modal");
    });

    N2.bindHandler('change', '.js-print-provider-form', (evt) => {
      const [jobId, form] = [evt.currentTarget.dataset.jobId, new N2Styles.manualForm()];

      form.setUrl(`/publication_jobs/${jobId}/prepress_updates`);
      form.addInput('publication_job_id', jobId);
      form.addInput('publication_job[print_provider_id]', evt.currentTarget.value);
      form.form.attr('method', 'patch');
      form.sync({
        success: (resp) => { this.handlePrepressUpdate(resp); },
        error: () => {
          new N2Styles.toast('Something went wrong. Please try again soon.');
        },
      });
    });
  }

  handlePrepressUpdate(resp) {
    if (resp.errors.length > 0) {
      if (resp.errors.includes('print_provider')) {
        new N2StylesModal('.js-invalid-print-provider-modal');
      } else {
        new N2Styles.toast(resp.message);
      }
    } else {
      new N2Styles.toast(resp.message);
    }
  }

  bindPrepressSubmit() {
    N2.bindHandler('click', '.js-prepress-submit', (evt) => {
      evt.preventDefault();
      new N2StylesModal('.js-submit-prepress-modal');
    });
  }

  bindFinishButtons() {
    N2.bindHandler("click", "#finish-design-button, #finish-design-review-button, #finish-design-revisions-button", function(e) {
      let url = $(this).data("url");
      let modalId = $(this).data("modal");
      $.get(url, { format: "json" }, function(data) {
        if (data["errors"].length > 0) {
          new N2Styles.toast(data["errors"]);
        } else {
          new N2StylesModal(modalId);
        }
      });
    });

    N2.bindHandler("click", "#submit-revisions-button, #finish-csr-revisions-button", function(e) {
      let modalId = $(this).data("modal");
      new N2StylesModal(modalId);
    });
  }

  bindDesignErrorHandler() {
    N2.handle("click", ".js-idj-errors", () => {
      new N2StylesModal(".js-show-in-design-errors");
    })
  }

  sortPubs(keys, klass){
    keys.forEach((ele) => {
      if ($(`.js-${ele}-pubs-react-data`).length) {
        let data = $(`.js-${ele}-pubs-react-data`).data("jobs");
        let list = new klass({
          sortScope: `#sort-filters-${ele}`,
          selector: `.js-${ele}-pubs-table`,
          data: data,
          roleType: this.role
        });
        if (this.csrFilter) {
          this.csrFilter.addList(ele, data, list);
        }
        list.render()
      }
    });
  }

  bindProofTypeHandler() {
    N2.bindHandler("change", "#publication_job_proof_types_form input", () => {
      const form = document.querySelector("#publication_job_proof_types_form");
      Rails.fire(form, "submit");
    });
  }

  bindManagedListUpload() {
    N2.handle("change", "#managed_mailing_list_asset_attributes_file", (evt) => {
      const field = $(evt.currentTarget);
      if (field.val() != null) {
        N2.showProgressIndicator();
        field.closest("form").submit();
      }
    });
    N2.handle("click", ".js-managed-list-submit", (e) => {
      $("[data-js-file]").click();
      e.preventDefault();
    });
    $(".js-address-upload-failed-modal").modal();
  }
}
